<div class="container-modal-lateral">
  <div>
    <span class="title-modal-lateral">{{ visualizar ? 'Detalhes Fluxo' : 'Cadastrar/Editar Fluxo' }}</span>

    @if(!visualizar){
      <div class="main-modal-lateral-edicao">
        <app-slide-toggle-padrao style="width: calc(50% - 5px)" [valor]="fluxo.ativo" (changeValue)="fluxo.ativo = $event; alteracaoService.camposAlterado()"></app-slide-toggle-padrao>
        <app-form-field style="width: calc(50% - 5px)" label="Fluxo de Erro" [isCheckbox]="true" [value]="isErro" (changeValue)="isErro = $event; alteracaoService.camposAlterado()"></app-form-field>
        <app-form-field label="Título" heightFormField="35px" [value]="fluxo.titulo" (changeValue)="fluxo.titulo = $event; alteracaoService.camposAlterado()"></app-form-field>
        <app-form-field label="Descrição" heightFormField="35px" [value]="fluxo.descricao" (changeValue)="fluxo.descricao = $event; alteracaoService.camposAlterado()"></app-form-field>
      </div>
    }@else {
      <div class="main-modal-lateral-info">
        <div class="container-info-modal-lateral">
          <span class="label">Título</span>
          <span class="font-12 ellipse">{{ fluxo.titulo }}</span>
        </div>
        <div class="container-info-modal-lateral">
          <span class="label">Descrição</span>
          <span class="font-12 ellipse">{{ fluxo.descricao }}</span>
        </div>
        <div class="flex-direction-row justify-between">
          <div class="container-info-modal-lateral">
            <span class="label">Ativo</span>
            <span class="font-12 ellipse">{{ fluxo.ativo ? 'Sim' : 'Não' }}</span>
          </div>
          <div class="container-info-modal-lateral">
            <span class="label">Tipo</span>
            <span class="font-12 ellipse">{{ fluxo.tipo }}</span>
          </div>
        </div>
      </div>
    }
  </div>
  @if (!visualizar) {
    <div class="botoes-modal-lateral">
      <app-button-padrao width="100%" label="Salvar" backgroundColor="var(--verde-padrao)" color="white" (buttonClick)="salvar()"></app-button-padrao>
      <app-button-padrao width="100%" label="Cancelar" backgroundColor="white" color="var(--vermelho-padrao)" (buttonClick)="cancelar()"
                         borderColor="var(--vermelho-padrao)" borderStyle="solid" borderWidth="1px"></app-button-padrao>
    </div>
  }
</div>
